export default "__VITE_ASSET__CAFR9g25__"